import { Badge, Button, Group } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useBillingPlan } from '../../hooks/useBilling';
import { AccountUtils } from '../../AccountUtils';

/**
 * Persistent header notice for trial accounts: days remaining + upgrade CTA.
 * Renders nothing for non-trial accounts. Audience gating matches legacy
 * canDisplayTrialActionsToUse implicitly — useBillingPlan only fetches for
 * parent-account users with billingRead, so everyone else gets null here.
 */
export function TrialHeaderNotice() {
  const navigate = useNavigate();
  const { billingPlan } = useBillingPlan();

  if (billingPlan?.billingPlan.billingPlanType !== 'trial') return null;

  const daysRemaining = AccountUtils.trialDaysRemaining(
    billingPlan.expires,
    Math.floor(Date.now() / 1000),
  );

  return (
    // Hidden below `sm`: the 60px header can't fit it on phones without
    // wrapping over page content; "Upgrade Plan" stays reachable in the nav.
    <Group gap="xs" wrap="nowrap" visibleFrom="sm">
      <Badge
        size="lg"
        variant="light"
        color={AccountUtils.trialUrgencyColor(daysRemaining)}
        tt="none"
        fw={500}
      >
        {AccountUtils.trialStatusMessage(daysRemaining)}
      </Badge>
      <Button size="sm" onClick={() => navigate({ to: '/account/upgrade-trial' })}>
        Upgrade
      </Button>
    </Group>
  );
}
